module.exports = __webpack_public_path__ + "img/join-us-4.005842a7.png";